var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoneco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 48,
    viewBox: "0 0 27 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.788 15.4725C17.5084 15.4725 20.5243 12.4566 20.5243 8.73626C20.5243 5.01593 17.5084 2 13.788 2C10.0677 2 7.05176 5.01593 7.05176 8.73626C7.05176 12.4566 10.0677 15.4725 13.788 15.4725Z",
    fill: "#FFB800",
    stroke: "#FF7D06",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5769 27.2611C25.5769 24.1346 24.3349 21.1362 22.1242 18.9254C19.9134 16.7147 16.915 15.4727 13.7885 15.4727C10.662 15.4727 7.66353 16.7147 5.45276 18.9254C3.242 21.1362 2 24.1346 2 27.2611V32.3133H7.0522L8.73626 45.7858H18.8407L20.5247 32.3133H25.5769V27.2611Z",
    fill: "#FFB800",
    stroke: "#FF7D06",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoneco);
export default __webpack_public_path__ + "static/media/boneco.4e433086cc2090e64744882626858a55.svg";
export { ForwardRef as ReactComponent };